import { Application } from "@hotwired/stimulus"
import FileUploadController from "../controllers/file_upload_controller"
import SortableTableController from "../controllers/sortable_table_controller"
import PasswordGeneratorController from "../controllers/password_generator_controller"
import TaskPlanningController from "../controllers/task_planning_controller"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Register controllers
application.register("file-upload", FileUploadController)
application.register("sortable-table", SortableTableController)
application.register("password-generator", PasswordGeneratorController)
application.register("task-planning", TaskPlanningController)

export { application }